<template>
  <div class="vacancy-files-edit">
    <div class="vacancy-files-edit__head">
      <div class="vacancy-files-edit__dropzone_wrap">
        <div ref="dropzone"
               :class="{'_drag-over': dragoverMixin}"
               @drop.prevent="onDropMixin($event)"
               @dragover.prevent="onDragenterMixin"
               @dragleave.prevent="onDragleaveMixin"
               class="vacancy-files-edit__dropzone">
          <input
            ref="fileInput"
            class="d-none"
            type="file"
            multiple
            :accept="typeFiles()"
            @change="onFilesInputMixin"
          >
          <button
            type="button"
            @click="$refs.fileInput.click()"
            class="vacancy-files-edit__btn-add base-btn base-btn--blue">
            <BasePreloader v-if="pending" />
            <BaseSvg name="ico-plus"/>
            <span class="base-btn__text">{{$tNewVacancy2('Add')}}</span>
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="value.length"
      class="vacancy-files-edit__list-wrap">
      <h4 class="vacancy-files-edit__list-title">
        {{$tNewVacancy2('Already downloaded')}}:
      </h4>
      <div class="vacancy-files-edit__list">
        <div
          v-for="(file, index) in value"
          :key="index"
          class="vacancy-files-edit__file">
          <div class="vacancy-files-edit__file-label">
            {{ file.name }}
          </div>
          <div class="vacancy-files-edit__file-info">
            <span>
              {{ file.ext }},
            </span>
            {{ file.size | formatSize}}
          </div>
          <button type="button"
                  @click.prevent="onDelete(file.id)"
                  class="vacancy-files-edit__btn-remove reset-button">
            <BaseSvg name="ico-close"/>
          </button>
        </div>
      </div>
    </div>

    <BaseAlertInline :value="errorMixin"
                     class="vacancy-files-edit__errors  _error"/>
  </div>
</template>

<script>
  import fileUploadMixin from '../../mixins/fileUploadMixin'
  import BaseAlertInline from '../BaseAlertInline'
  import {ALLOWED_IMAGES_EXTS, VIDEOS_TYPES, ALLOWED_OTHER_EXTS} from '../../constants/files'

  export default {
    name: 'EditFiles',
    components: {BaseAlertInline},
    mixins: [fileUploadMixin],
    props: {
      value: Array,
      error: [Object, Array, String],
      pending: {
        type: Boolean,
        default: false
      },
      max: {
        type: Number,
        default: 30
      }
    },
    data() {
      return {
        uploadFileMethodNameMixin: ['upload']
      }
    },
    methods: {
      upload(files) {
        this.$emit('input', files)
      },
      onDelete(index) {
        this.$emit('delete', index)
      },
      typeFiles() {
        const concatTypesArray = ALLOWED_IMAGES_EXTS.concat(VIDEOS_TYPES, ALLOWED_OTHER_EXTS)
        const typesString = concatTypesArray.join(', .')

        return '.' + typesString
      }
    },
    watch: {
      error(value) {
        if (value) {
          this.errorMixin = value
        }
      }
    }
  }
</script>

<style>

</style>
